import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Contact from "./Contact";
import Home from "./Home";
import Navbar from "./Navbar";
import ScrollToTop from "./ScrollTop";
import Team from "./Team";
import CareerDetailsWrapper from "./careers/CareerDetailsWrapper";
import Career from "./careers/career";
import Service from "./service/Service";
import ServiceDetailsWrapper from "./service/ServiceDetailsWrapper";
import Footer from "./Footer";

const App = () => {
  const [fontSize, setFontSize] = useState(16);

  useEffect(() => {
    document.documentElement.style.setProperty("--base-font-size", `${fontSize}px`);
  }, [fontSize]);

  const increaseFont = () => setFontSize((prev) => Math.min(prev + 1, 30));
  const decreaseFont = () => setFontSize((prev) => Math.max(prev - 1, 12));

  return (
    <>
      <Navbar onIncreaseFont={increaseFont} onDecreaseFont={decreaseFont} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/career" element={<Career />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/service-details" element={<ServiceDetailsWrapper />} />
        <Route path="/career-details" element={<CareerDetailsWrapper />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
